<div class="loader-wrapper" *ngIf="isLoading">
  <img [src]="loader" />
</div>
